var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7499 5.24999C15.7499 8.14953 13.3994 10.5 10.4999 10.5C7.60033 10.5 5.24988 8.14953 5.24988 5.24999C5.24988 2.35045 7.60033 0 10.4999 0C13.3994 0 15.7499 2.35045 15.7499 5.24999Z",
    fill: "#A4A4A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6776 12.8177C8.70676 12.4822 5.73419 13.4294 3.5046 15.4209C1.275 17.4127 0.000342587 20.2604 0 23.2501V24.7501C0 25.3467 0.23705 25.9193 0.658928 26.3411C1.0808 26.7629 1.65338 27 2.24995 27H18.7499C19.3466 27 19.9192 26.763 20.341 26.3411C20.7628 25.9192 20.9999 25.3466 20.9999 24.7501V23.5501C21.0307 20.9298 20.0985 18.3891 18.3799 16.4107C16.6613 14.4322 14.2765 13.1535 11.6776 12.8177Z",
    fill: "#A4A4A4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.12891d0c5f7996ebe8ea4ead2ee0a411.svg";
export { ForwardRef as ReactComponent };